import { api } from '../lib/api';
import type { ApiResponse, Plan, BannerPlan, Testimonial, Impulse } from '../types';

export interface PublicStats {
  total_companies: number;
  total_jobs: number;
  active_jobs: number;
  total_candidates: number;
  jobs_filled?: number;
}

class PublicService {
  async getPublicStats(): Promise<PublicStats> {
    const response = await api.get<ApiResponse<PublicStats>>('/public/stats');
    return response.data;
  }

  async getPlans(): Promise<Plan[]> {
    const response = await api.get<ApiResponse<Plan[]>>('/public/plans');
    return response.data;
  }

  async getBannerPlans(): Promise<BannerPlan[]> {
    const resp = await api.get<unknown>('/public/banner-plans');
    if (Array.isArray(resp)) return resp as BannerPlan[];
    const anyResp = resp as Record<string, unknown>;
    if (Array.isArray(anyResp.data)) return anyResp.data as BannerPlan[];
    if (anyResp.data && Array.isArray((anyResp.data as any).data)) return (anyResp.data as any).data as BannerPlan[];
    return [];
  }

  async getTestimonials(): Promise<Testimonial[]> {
    const resp = await api.get<unknown>('/public/testimonials');
    if (Array.isArray(resp)) return resp as Testimonial[];
    const anyResp = resp as any;
    if (anyResp && typeof anyResp === 'object') {
      if (Array.isArray(anyResp.data)) return anyResp.data as Testimonial[];
      if (anyResp.data && Array.isArray(anyResp.data.data)) return anyResp.data.data as Testimonial[];
    }
    return [];
  }

  async getImpulses(): Promise<Impulse[]> {
    const resp = await api.get<unknown>('/public/impulses');
    if (Array.isArray(resp)) return resp as Impulse[];
    const anyResp = resp as any;
    if (anyResp && typeof anyResp === 'object') {
      if (Array.isArray(anyResp.data)) return anyResp.data as Impulse[];
      if (anyResp.data && Array.isArray(anyResp.data.data)) return anyResp.data.data as Impulse[];
    }
    return [];
  }
}

export const publicService = new PublicService();
